// Auto generated file, do not manually modify!
// com.hotpads.satellite.client.conversation.type.SatelliteConversationFeatureType

export enum SatelliteConversationFeatureType {
  APPROVE_APPLICATION = 'APPROVE_APPLICATION',
  APPROVE_OFF_PLATFORM = 'APPROVE_OFF_PLATFORM',
  INVITE_TO_APPLY = 'INVITE_TO_APPLY',
  INVITE_TO_MOVE_IN = 'INVITE_TO_MOVE_IN',
  INVITE_TO_PAYMENTS = 'INVITE_TO_PAYMENTS',
  REQUEST_RENTER_PROFILE = 'REQUEST_RENTER_PROFILE',
  SCHEDULE_TOUR = 'SCHEDULE_TOUR',
  SEND_MESSAGE = 'SEND_MESSAGE',
  VIEW_MESSAGES = 'VIEW_MESSAGES',
  VIEW_RENTER_JOURNEY = 'VIEW_RENTER_JOURNEY',
  VIEW_SCREENING_CRITERIA = 'VIEW_SCREENING_CRITERIA',
  VIEW_TOUR_DETAILS = 'VIEW_TOUR_DETAILS',
}

export const SatelliteConversationFeatureType_values = [
  SatelliteConversationFeatureType.APPROVE_APPLICATION,
  SatelliteConversationFeatureType.APPROVE_OFF_PLATFORM,
  SatelliteConversationFeatureType.INVITE_TO_APPLY,
  SatelliteConversationFeatureType.INVITE_TO_MOVE_IN,
  SatelliteConversationFeatureType.INVITE_TO_PAYMENTS,
  SatelliteConversationFeatureType.REQUEST_RENTER_PROFILE,
  SatelliteConversationFeatureType.SCHEDULE_TOUR,
  SatelliteConversationFeatureType.SEND_MESSAGE,
  SatelliteConversationFeatureType.VIEW_MESSAGES,
  SatelliteConversationFeatureType.VIEW_RENTER_JOURNEY,
  SatelliteConversationFeatureType.VIEW_SCREENING_CRITERIA,
  SatelliteConversationFeatureType.VIEW_TOUR_DETAILS,
] as const;
